import React from "react";
import SectionHeader from "./common/SectionHeader";
import Row from "./common/Row";
import Field from "./common/Field";
import { config } from "./common/config";
import { StyleSheet } from "@react-pdf/renderer";
import Notes from "./Notes";
import Users from "./Users";
const styles = StyleSheet.create({
  container: {
    borderColor: config.accentColor,
    borderWidth: 2,
    marginLeft: 5,
    paddingLeft: 5,
  },
  subtext: {
    color: config.grayColor,
    fontSize: config.normalFontSize + 1,
    marginBottom: 5,
  },
  subtitle: {
    width: "100%",
    borderBottomWidth: 2,
    borderBottomColor: "#118052",
    paddingBottom: 2,
    marginBottom: 4,
  },
  bottomBorder: {
    borderBottomColor: config.grayColor,
    borderBottomWidth: 1,
    marginBottom: 3,
    paddingTop: 5,
  },
});

const FlowData = ({ relatory }) => {
  return (
    <>
      <Row>
        <SectionHeader>Informações Gerais</SectionHeader>
      </Row>
      <Row>
        <Field label="Estado do Fluxo">
          {relatory?.flow.finishedAt ? "Finalizado" : "Em andamento"}
        </Field>
        <Field label="Tarefas em dia">
          {relatory?.taskLog.doing.toString()}
        </Field>
        <Field label="Tarefas Atrasadas">
          {relatory?.taskLog.late.toString()}
        </Field>
      </Row>

      <Row>
        <Field label="Tarefas Concluídas">
          {relatory?.taskLog.done.toString()}
        </Field>
        <Field label="Tarefas Concluídas em Atraso">
          {relatory?.taskLog.doneLate.toString()}
        </Field>
        <Field label="Tarefas Pendentes">
          {relatory?.taskLog.pending.toString()}
        </Field>
      </Row>

      <Row>
        <Field label="Tarefas Delegadas">
          {relatory?.taskLog.acc.toString()}
        </Field>
        <Field label="Tarefas Não Delegadas">
          {relatory?.taskLog.nonAcc.toString()}
        </Field>
        <Field label="Tarefas Totais">
          {(relatory?.taskLog.acc + relatory?.taskLog.nonAcc).toString()}
        </Field>
      </Row>

      {relatory.relatedUsers && relatory.relatedUsers.length > 0 && (
        <React.Fragment>
          <Row style={styles.subtitle}>
            <SectionHeader>Relacionados</SectionHeader>
          </Row>
          <Users relatory={relatory} />
        </React.Fragment>
      )}

      {relatory?.notes.length > 0 && (
        <React.Fragment>
          <Row style={styles.subtitle}>
            <SectionHeader>Anotações do Fluxo</SectionHeader>
          </Row>
          <Notes notes={relatory.notes} />
        </React.Fragment>
      )}
    </>
  );
};

export default FlowData;
